import { memo, useCallback } from 'react';
import { TextAsset } from '../types';
import { handlePostLockedError } from '@/Pages/Clip/utils';
import IconButton from '@/components/atoms/Button/IconButton';

const PostListItemLockButton = ({ post }: { post: TextAsset }) => {
  const onPostLockClick = useCallback(
    e => {
      e.stopPropagation();
      handlePostLockedError(post, 'edit');
    },
    [post]
  );

  if (!post.locked) {
    return null;
  }

  return (
    <IconButton
      icon="IconLock"
      title={`Post is published in ${post?.content?.project?.title}'s on-demand page and cannot be edited. Please un-publish to continue editing.`}
      onClick={onPostLockClick}
      trackingId="posts-list-item-locked-button"
      variation="outline"
      iconClassName="h-4 w-4 text-slate-600"
      buttonClassName="h-6 w-6 bg-white/80"
    />
  );
};

export default memo(PostListItemLockButton);
